export default "__VITE_ASSET__JN0d0995__"